import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-powerpoints',
  templateUrl: './powerpoints.component.html',
  styleUrls: ['./powerpoints.component.scss']
})
export class PowerpointsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
